import type { CSSProperties, FC } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';

export const CheckboxHolder = styled.div`
  position: relative;
`;

export const CheckboxLabel = styled.label`
  display: block;
  height: 24px;
  width: 24px;
  right: 10px;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color ease-out 0.2s;
  &:hover {
    border-color: ${({ theme }) => theme.colors.purpleLighter};
  }
`;

export const Checkbox = styled.input`
  display: none;
  &:checked + ${CheckboxLabel} {
    background: ${({ theme }) => theme.colors.purple};
    border-color: transparent;
    &:after {
      content: '';
      position: absolute;
      left: 8px;
      top: 3px;
      width: 8px;
      height: 14px;
      border: solid ${({ theme }) => theme.colors.white};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;

const Row = styled.div`
  display: flex;
  padding: 16px 24px;
  gap: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  align-items: center;
`;

const Column = styled.div`
  word-wrap: break-word;
  flex: 1;
`;

const FirstColumn = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  width: 24px;
  flex-shrink: 0;
`;

interface Props {
  style: CSSProperties;
  comment: {
    id: string;
    message: string;
  };
  isChecked: boolean;
  onCheck: () => void;
}

const CommentRow: FC<Props> = ({ comment, style, isChecked, onCheck }) => {
  return (
    <Row style={style}>
      <FirstColumn>
        <CheckboxHolder>
          <Checkbox
            id={`comment-${comment.id}`}
            name="products"
            type="checkbox"
            checked={isChecked}
            onChange={onCheck}
          />
          <CheckboxLabel htmlFor={`comment-${comment.id}`} />
        </CheckboxHolder>
      </FirstColumn>
      <Column>
        <Text $type="smallBold">{comment.message ?? '-'}</Text>
      </Column>
    </Row>
  );
};

export default CommentRow;
